<header>
  <div class="container">
    <!-- {{ 'COMPARTIDOS.SUB_HEADER.' + title }} -->
    <p class="sub-header">{{ 'COMPARTIDOS.SUB_HEADER.' + title | translate }}</p>
  </div>
</header>
